var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var editor_2d = require("editor-2d");

var PropertyInteractionModel = function(propertyData, editorModel, options) {

    editor_2d.TextInteractionModel.call(this, propertyData.textData(), editorModel);
    
    propertyData.textData().onRemove(this, function () {
        propertyData.remove();
    });
};
lib_core.inherit(PropertyInteractionModel, editor_2d.TextInteractionModel);
lib_core.JsonParser.registerClass(PropertyInteractionModel, "PropertyInteractionModel");

module.exports = PropertyInteractionModel;
